import React from 'react';
import { observer } from 'mobx-react';
import { Card, Button, Text } from '@servicetitan/design-system';

interface DocumentDetailsCardProps {
    header?: string | null;
    documentPdfUrl?: string | null;
}

export const DocumentDownloadCard: React.FC<DocumentDetailsCardProps> = observer(
    ({ header, documentPdfUrl }) => (
        <Card className="m-t-4">
            <Card.Section className="fw-bold">
                <Text className="m-b-1">{header}</Text>
                <Button full primary href={documentPdfUrl!}>
                    Download Document
                </Button>
            </Card.Section>
        </Card>
    )
);
